<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("setting.manage_role") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="go2AddPage"
    >
      {{ $t("common.add_new") }}
    </md-button>
  </div>
</template>

<script>
import { role_router_names } from "@/routes/routes";
import { RolePage } from "@/constants/Permissions";
export default {
  name: "ListPageHeader",
  computed: {
    canAdd() {
      return this.$can(RolePage.actions.add, RolePage.subject);
    }
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: role_router_names.addPage });
    }
  }
};
</script>
